import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "terms-view relative h-full" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "flex mt-5" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "flex mt-5" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex mt-5" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  id: "accept-button",
  class: "fixed z-19 bottom-[80px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_db_checkbox = _resolveComponent("db-checkbox")!
  const _component_db_button = _resolveComponent("db-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("landing.terms_and_conditions_description")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_db_checkbox, {
        label: "",
        name: "",
        onChange: _cache[0] || (_cache[0] = (e) => _ctx.toggleCondition('general_terms_and_conditions')),
        id: "general_terms_and_conditions"
      }),
      _createElementVNode("label", {
        for: "general_terms_and_conditions",
        innerHTML: _ctx.$t('landing.general_terms_and_conditions'),
        class: "text-left"
      }, null, 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_db_checkbox, {
        label: "",
        name: "",
        onChange: _cache[1] || (_cache[1] = (e) => _ctx.toggleCondition('link2rail_terms_of_use')),
        id: "link2rail_terms_of_use"
      }),
      _createElementVNode("label", {
        for: "link2rail_terms_of_use",
        innerHTML: _ctx.$t('landing.link2rail_terms_of_use'),
        class: "text-left"
      }, null, 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_db_checkbox, {
        label: "",
        name: "",
        onChange: _cache[2] || (_cache[2] = (e) => _ctx.toggleCondition('link2rail_data_protection_notice')),
        id: "link2rail_data_protection_notice"
      }),
      _createElementVNode("label", {
        for: "link2rail_data_protection_notice",
        innerHTML: _ctx.$t('landing.link2rail_data_protection_notice'),
        class: "text-left"
      }, null, 8, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_db_button, {
        onClick: _ctx.submit,
        class: "hydrated",
        variant: "brand-primary",
        disabled: _ctx.notAllTermsAccepted
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("landing.accept")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "disabled"]),
      _createVNode(_component_db_button, {
        onClick: _ctx.logout,
        class: "hydrated",
        variant: "tertiary-plain"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("main.logout")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}